import $ from 'jquery'

const cloneDetailImage = () => {
  const $image = $('.js-detail-main-image')
  const CLONE_CLASS = '-is-clone'

  if (!$image.length) {
    return
  }

  const $clone = $image.children().clone()

  $clone.addClass(CLONE_CLASS)
  $image.append($clone)
}

export default cloneDetailImage
